import { observer } from 'mobx-react'
import {
  Block,
  Button,
  Heading,
  IconArrowRight,
  Paragraph,
} from 'suomifi-ui-components'
import LocalizedString, {
  LocalizedParagraphs,
  LocalizedParagraphsStringKey,
} from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'

interface AetFinallyBackToLandingPageProps {
  descriptionStringKey: string
  additionalParagraphsStringKey?: LocalizedParagraphsStringKey
}

const AetFinallyBackToLandingPage: React.FC<AetFinallyBackToLandingPageProps> =
  observer(({ descriptionStringKey, additionalParagraphsStringKey }) => {
    const {
      common: { lang },
    } = useStore()

    return (
      <Block variant="section">
        <Heading variant="h3">
          <LocalizedString stringKey="aetFinallyBackToLandingPageTitle" />
        </Heading>
        <Paragraph>
          <LocalizedString stringKey={descriptionStringKey} />
        </Paragraph>
        {additionalParagraphsStringKey && (
          <LocalizedParagraphs stringKey={additionalParagraphsStringKey} />
        )}
        <Paragraph>
          <Button
            iconRight={<IconArrowRight />}
            variant="secondary"
            onClick={() => {
              window.location.href = `/${lang}#top`
            }}
          >
            <LocalizedString stringKey="orderWizardReturnToFrontPageLinkText" />
          </Button>
        </Paragraph>
      </Block>
    )
  })

export default AetFinallyBackToLandingPage
